// @flow
import { captureException, withScope } from '@rover/utilities/sentry';

type ErrorType = Error | string;

function getErrorObject(error: ErrorType): Error {
  return typeof error === 'string' ? new Error(error) : error;
}

const reportError = (error: ErrorType) => {
  const errorObject: Error = getErrorObject(error);
  if (process.env.NODE_ENV === 'development') throw errorObject;

  withScope(scope => {
    scope.setExtra('stacktrace', errorObject.stack);
    captureException(errorObject);
  });
};

export default reportError;



// WEBPACK FOOTER //
// ../utilities/reportError.js